import React from "react";
import { IconProps } from "../icon";

export const RefreshCcw_04Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 18.875A8.5 8.5 0 0012 3.5h-.5m.5 17A8.5 8.5 0 017 5.125M11 22.4l2-2-2-2m2-12.8l-2-2 2-2"
    />
  </svg>
);
